const encryptDecryptKey = [
  {
    plainLetter: "a",
    codedLetter: "q",
  },
  {
    plainLetter: "b",
    codedLetter: "w",
  },
  {
    plainLetter: "c",
    codedLetter: "e",
  },
  {
    plainLetter: "d",
    codedLetter: "r",
  },
  {
    plainLetter: "e",
    codedLetter: "t",
  },
  {
    plainLetter: "f",
    codedLetter: "y",
  },
  {
    plainLetter: "g",
    codedLetter: "u",
  },
  {
    plainLetter: "h",
    codedLetter: "i",
  },
  {
    plainLetter: "i",
    codedLetter: "o",
  },
  {
    plainLetter: "j",
    codedLetter: "p",
  },
  {
    plainLetter: "k",
    codedLetter: "a",
  },
  {
    plainLetter: "l",
    codedLetter: "s",
  },
  {
    plainLetter: "m",
    codedLetter: "d",
  },
  {
    plainLetter: "n",
    codedLetter: "f",
  },
  {
    plainLetter: "o",
    codedLetter: "g",
  },
  {
    plainLetter: "p",
    codedLetter: "h",
  },
  {
    plainLetter: "q",
    codedLetter: "j",
  },
  {
    plainLetter: "r",
    codedLetter: "k",
  },
  {
    plainLetter: "s",
    codedLetter: "l",
  },
  {
    plainLetter: "t",
    codedLetter: "z",
  },
  {
    plainLetter: "u",
    codedLetter: "x",
  },
  {
    plainLetter: "v",
    codedLetter: "c",
  },
  {
    plainLetter: "w",
    codedLetter: "v",
  },
  {
    plainLetter: "x",
    codedLetter: "b",
  },
  {
    plainLetter: "y",
    codedLetter: "n",
  },
  {
    plainLetter: "z",
    codedLetter: "m",
  },
];

export default encryptDecryptKey;
